import React, { useEffect, useState } from 'react';
import { ClockIcon, LeafIcon } from 'lucide-react';
import { ScrollReveal } from './ui/ScrollReveal';
export function HeroSection() {
  // 30 minutes in seconds
  const [timeLeft, setTimeLeft] = useState(30 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <section className="relative w-full bg-gradient-to-b from-cream to-sage pb-16 pt-0 overflow-hidden" data-id="element-71">
      {/* Urgency Banner */}
      <div className="w-full bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base animate-slide-down shadow-md z-10 relative flex items-center justify-center gap-2" data-id="element-72">
        <span className="animate-pulse" data-id="element-73">🔴</span> OFERTA DE LANZAMIENTO: 70% OFF
        SOLO POR 30 MINUTOS
      </div>

      <div className="max-w-4xl mx-auto px-4 pt-12 md:pt-20 text-center relative z-0" data-id="element-74">
        {/* Decorative Leaves */}
        <LeafIcon className="absolute top-10 left-4 md:left-10 w-12 h-12 text-forest opacity-20 transform -rotate-45" data-id="element-75" />
        <LeafIcon className="absolute top-20 right-4 md:right-10 w-16 h-16 text-forest opacity-20 transform rotate-45" data-id="element-76" />

        <ScrollReveal data-id="element-77">
          <div className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm border border-forest/20 text-forest px-4 py-2 rounded-full font-semibold mb-8 shadow-sm" data-id="element-78">
            <ClockIcon className="w-5 h-5 animate-countdown-pulse" data-id="element-79" />
            <span className="font-mono text-lg tracking-wider" data-id="element-80">
              {formatTime(timeLeft)}
            </span>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={100} data-id="element-81">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-[#DC2525]" data-id="element-82">
            Ahorrá mas de $50.000 por mes en remedios, sin salir de tu casa con
            el <span className="text-forest" data-id="element-83">BOTIQUÍN ANCESTRAL</span>
          </h1>
        </ScrollReveal>

        <ScrollReveal delay={200} data-id="element-84">
          <p className="font-sans text-lg md:text-xl text-brown/80 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-85">
            Recuperá la sabiduría de nuestras abuelas. Aprendé a armar tu propio
            Botiquín en Casa por menos de lo que cuesta un solo jarabe
            industrial.{' '}
            <strong className="text-brown font-bold" data-id="element-86">
              Incluso si vivís en un departamento y no tenés jardín.
            </strong>
          </p>
        </ScrollReveal>

        <ScrollReveal delay={300} data-id="element-87">
          <div className="mb-10" data-id="element-88">
            <img src="https://cdn.magicpatterns.com/uploads/t8MbsHq6sN5tfKStYECKy6/EBOOK_PRINCIPAL.png" alt="Botiquín Ancestral - Ebook en libro, tablet y celular" className="w-full max-w-2xl mx-auto rounded-2xl shadow-2xl border-2 border-forest/10" data-id="element-89" />
          </div>
        </ScrollReveal>

        <ScrollReveal delay={400} data-id="element-90">
          <a href="#oferta-especial" className="inline-block w-full md:w-auto bg-forest text-white font-bold text-lg md:text-xl px-8 py-5 rounded-xl animate-pulse-glow hover:bg-forest/90 transition-colors shadow-lg transform hover:-translate-y-1" data-id="element-91">
            🛒 SÍ, QUIERO MI BOTIQUÍN AHORA ($17.990)
          </a>
          <p className="mt-4 text-sm text-brown/60 font-medium flex items-center justify-center gap-1" data-id="element-92">
            🔒 Compra 100% segura y garantizada
          </p>
        </ScrollReveal>
      </div>
    </section>;
}